import React from 'react'
import { Accordion } from "react-bootstrap";

const MapTab = () => {
  return (
    <>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0" className="tab-content" id="collapseFive">
          <Accordion.Body className="p-0 overflow-hiden border-radious">
            <iframe
              src="https://www.google.com/maps?q=22.576499,78.143830&hl=es&z=13&output=embed"
              width="100%"
              height="480"
              title="map"
              frameborder="0"
              style={{
                border: "0",
              }} allowfullscreen ></iframe>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  )
}

export default MapTab